import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { IdeaKaizen } from './graphql/ideaKaizen.graphql';
import { GetSustainabilitiesDocument, GetSustainabilitiesQuery, GetSustainabilitiesQueryVariables } from './graphql/sustainability/sustainability.graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export class Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
};

export class Sustainability {
  id: Scalars['ID'];
  name: Scalars['String'];
  quantity: Scalars['Float'];
  unity: Scalars['String'];
  pontuation: Scalars['Float'];
  ideaId: Scalars['ID'];
  type: 'water' | 'energy' | 'waste';
};


export class AcceptIdeaCommitteeInput {
  id: Scalars['String'];
};

export class AcceptIdeaInput {
  committee: AcceptIdeaCommitteeInput;
  id: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export class ConcludeIdeaInput {
  responsible:  Scalars['String'];
  term: Scalars['String'];
  DateOfTheConclusion: Scalars['String'];
  financial?: Scalars['Float'];
  productivity?: Scalars['Float'];
  sustainability?: Scalars['Float'];
};

export class Action {
  code: Scalars['String'];
  comments?: Maybe<Array<ActionComment>>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  endDate: Scalars['DateTime'];
  files?: Maybe<Array<ActionFile>>;
  history?: Maybe<Array<ActionHistory>>;
  id: Scalars['ID'];
  idea?: Maybe<Idea>;
  responsible?: Maybe<User>;
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
  tasks?: Maybe<Array<ActionTask>>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class ActionComment {
  action?: Maybe<Action>;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  user?: Maybe<User>;
};

export class ActionFile {
  action?: Maybe<Action>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  fileName?: Scalars['String'];
  bucketRequestId: Scalars['String']
  eTag: Scalars['String']
  versionId: Scalars['String']
};

export class ActionHistory {
  action?: Maybe<Action>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  changedData: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  type: Scalars['String'];
  user?: Maybe<User>;
};

export class ActionHistoryPage {
  currentPage: Scalars['Int'];
  history: Array<ActionHistory>;
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previouPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class ActionKamban {
  action: Action;
  commentsCount: Scalars['Int'];
  doneTasks: Scalars['Int'];
  filesCount: Scalars['Int'];
  isDelayed: Scalars['Boolean'];
  totalTasks: Scalars['Int'];
};

export class ActionTask {
  action?: Maybe<Action>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['String'];
  status: Scalars['Boolean'];
};

export class ApproveIdeaExpectationsInput {
  /** Enum: "finance-admin", "productive-admin", "sustainability-admin" */
  expectation: Scalars['String'];
  expectationDescription: Scalars['String'];
};

export class ApproveIdeaInput {
  analysisDescription?: InputMaybe<Scalars['String']>;
  /** decimal(10,2) */
  analysisFinacialreturn?: InputMaybe<Scalars['Float']>;
  /** decimal(10,2) */
  analysisMachineValue?: InputMaybe<Scalars['Float']>;
  /** decimal(10,2) */
  analysisManValue?: InputMaybe<Scalars['Float']>;
  /** enum water|energy|waste */
  analysisSustainability?: InputMaybe<Scalars['String']>;
  expectations?: InputMaybe<Array<ApproveIdeaExpectationsInput>>;
  id: Scalars['ID'];
  implementationResume: Scalars['String'];
  premiationDate: Scalars['DateTime'];
  sustainability?: InputMaybe<Array<ApproveIdeaSustainabilityInput>>;
  productivityValueHH?: InputMaybe<Scalars['Float']>;
  sustentabilityPoint?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  authorName?: InputMaybe<Scalars['String']>;
  re?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  committee?: string;
  unity?: string;
};

export class ApproveIdeaSustainabilityInput {
  id: Scalars['String'];
};

export class Area {
  committee?: Maybe<Array<Committee>>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export class Frame {
  id: Scalars['ID'];
  name: Scalars['String'];
  manager: Scalars['String'];
};

export class AuthInput {
  application: Scalars['String'];
  code: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  redirectUri: Scalars['String'];
};

export class AuthType {
  country: Scalars['String'];
  token: Scalars['String'];
  user: User;
};

export class BaseInput {
  id: Scalars['String'];
};

/** Entity Challenge Object */
export class Challenge {
  id: Scalars['ID'];
  name: Scalars['String'];
  type: Scalars['String'];
  title: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  isDateSensitive?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  /** Enum pt-BR| es-ES */
  language: Scalars['String'];
  /** Enum active|inactive */
  status: Scalars['String'];
};

export class Committee {
  area?: Maybe<Area>;
  createdAt?: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  idea?: Maybe<Array<Idea>>;
  frames?: Maybe<Frame[]>;
  manager?: Maybe<User>;
  name: Scalars['String'];
  participants?: Maybe<User[]>;
  status: Scalars['Boolean'];
  kaizen: Scalars['Boolean'];
  unity?: Maybe<Unity>;
};

export class Country {
  flag: Scalars['String'];
  id: Scalars['ID'];
  language: Scalars['String'];
  name: Scalars['String'];
  unity: Array<Unity>;
};

export class CreateActionCommentActionInput {
  id: Scalars['String'];
};

export class CreateActionCommentInput {
  action: CreateActionCommentActionInput;
  comment: Scalars['String'];
};

export class CreateActionIdeaInput {
  id: Scalars['String'];
};

export class CreateActionInput {
  description: Scalars['String'];
  endDate: Scalars['DateTime'];
  ideaId: Scalars['String'];
  responsibleId: Scalars['String'];
  startDate: Scalars['DateTime'];
  status: Scalars['String'];
  title: Scalars['String'];
};

export class CreateActionResponsibleInput {
  id: Scalars['String'];
};

export class CreateActionTaskActionInput {
  id: Scalars['String'];
};

export class CreateActionTaskInput {
  action: CreateActionTaskActionInput;
  description: Scalars['String'];
};

export class CreateAreaInput {
  name: Scalars['String'];
};

/** Object create new challenge */
export class CreateChallengeInput {
  name: Scalars['String'];
  type: Scalars['String'];
  title: Scalars['String'];
  status: Scalars['String'];
  language: Scalars['String'];
  description: Scalars['String'];

  isDateSensitive: Scalars['Boolean'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export class CreateCommitteeAreaInput {
  id: Scalars['String'];
};

export class CreateCommitteeInput {
  area?: InputMaybe<CreateCommitteeAreaInput>;
  manager: CreateCommitteeManagerInput;
  name: Scalars['String'];
  participants: CreateCommitteeParticipantInput[];
  frames?: CreateFrameInput[];
  status: Scalars['Boolean'];
  kaizen?: Scalars['Boolean'];
  unity: CreateCommitteeUnityInput;
};

export class CreateCommitteeManagerInput {
  id: Scalars['String'];
};

export class CreateFrameInput {
  id: Scalars['String'];
};

export class CreateFrameManagerInput {
  id: Scalars['String'];
};

export class CreateCommitteeParticipantInput {
  id: Scalars['String'];
};

export class CreateCommitteeUnityInput {
  id: Scalars['String'];
};

export class CreateCountryInput {
  flag: Scalars['String'];
  name: Scalars['String'];
};

export class CreateIdeaAuthorInput {
  area?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<Scalars['String']>;
  cpf?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  jobRole?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  re: Scalars['String'];
};

export class CreateIdeaChallengeInput {
  id: Scalars['String'];
  language: Scalars['String'];
  type: Scalars['String'];
};

export class CreateIdeaCommentInput {
  message: Scalars['String'];
  name: Scalars['String'];
};

export class CreateIdeaConclusionIdeaInput {
  id: Scalars['String'];
};

export class CreateIdeaConclusionInput {
  /** enum not attend|parctially attends|attend|overcomes */
  financialVote: Scalars['String'];
  financialVoteDescription?: InputMaybe<Scalars['String']>;
  idea: CreateIdeaConclusionIdeaInput;
  points: Scalars['Float'];
  /** decimal(10,2) */
  prize: Scalars['Float'];
  /** enum not attend|parctially attends|attend|overcomes */
  productivityVote: Scalars['String'];
  productivityVoteDescription?: InputMaybe<Scalars['String']>;
  /** enum not attend|parctially attends|attend|overcomes */
  sustainabilityVote: Scalars['String'];
  sustainabilityVoteDescription?: InputMaybe<Scalars['String']>;
};

export class CreateIdeaCountryInput {
  id: Scalars['String'];
};

export class CreateIdeaExpectationInput {
  challengeLanguage?: InputMaybe<Scalars['String']>;
  expectation: Scalars['String'];
  expectationDescription: Scalars['String'];
};

export class CreateIdeaInput {
  areaExtensionLine?: Scalars['String'];
  areaResponsible?: Scalars['String'];
  authorName: Scalars['String'];
  code?: Scalars['String'];
  authors?: InputMaybe<Array<CreateIdeaAuthorInput>>;
  challenge?: CreateIdeaChallengeInput;
  contactHour?: Scalars['String'];
  costCenter?: Scalars['String'];
  country?: CreateIdeaCountryInput;
  description?: Scalars['String'];
  document: Scalars['String'];
  email?: Scalars['String'];
  expectation?: InputMaybe<Array<CreateIdeaExpectationInput>>;
  managerName?: Scalars['String'];
  phone?: Scalars['String'];
  phoneExtensionLine?: Scalars['String'];
  productiveDescription?: InputMaybe<Scalars['String']>;
  productiveEquipament?: Scalars['Boolean'];
  re?: Scalars['String'];
  role?: Scalars['String'];
  title: Scalars['String'];
  turn?: Scalars['String'];
  unity?: CreateIdeaUnityInput;
};

export class CreateIdeaUnityInput {
  id: Scalars['String'];
};

export class CreateNewsInput {
  author: Scalars['String'];
  content: Scalars['String'];
  description: Scalars['String'];
  /** Enum "published"|"unpublished" */
  status: Scalars['String'];
  tag?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export class CreateNotificationInput {
  additionalParticipants: Scalars['String'];
  applicant: Scalars['String'];
  contact: Scalars['String'];
  date: Scalars['DateTime'];
  description: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  ideaTitle: Scalars['String'];
  message: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  re: Scalars['String'];
  relationId: Scalars['String'];
  subject?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
  unity: Scalars['String'];
  user?: InputMaybe<NotificationUserInput>;
  userId?: Scalars['String'];
};

export class CreateTagInput {
  tag: Scalars['String'];
};

export class CreateUnityCountryInput {
  id: Scalars['String'];
};

export class CreateUnityInput {
  country: CreateUnityCountryInput;
  name: Scalars['String'];
};

export class CreateUserCommitteeInput {
  id: Scalars['String'];
};

export class CreateUserInput {
  commites: Array<CreateUserCommitteeInput>;
  email: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
  unity?: InputMaybe<CreateUserUnityInput>;
  re: Scalars['String'];
};

export class CreateUserUnityInput {
  id: Scalars['String'];
};

export class DashboardHome {
  approves: Scalars['Int'];
  energy: Scalars['Float'];
  finances: Scalars['Float'];
  machineValue: Scalars['Float'];
  manValue: Scalars['Float'];
  news: Scalars['Int'];
  waste: Scalars['Float'];
  water: Scalars['Float'];
};

export class DefaultMessage {
  message: Scalars['String'];
  status: Scalars['Int'];
};

export class Home {
  currentPage: Scalars['Int'];
  ideas: Array<Idea>;
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previouPage: Scalars['Boolean'];
  tasksCanceled: Scalars['Int'];
  tasksDone: Scalars['Int'];
  tasksInProgress: Scalars['Int'];
  tasksPending: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Entity Idea Object */
export class Idea {
  action?: Maybe<Array<Action>>;
  analysisDescription?: Maybe<Scalars['String']>;
  analysisFinacialreturn?: Scalars['Float'];
  analysisMachineValue?: Scalars['Float'];
  analysisManValue?: Scalars['Float'];
  analysisSustainability?: Maybe<Scalars['String']>;
  areaExtensionLine?: Maybe<Scalars['String']>;
  areaResponsible?: Maybe<Scalars['String']>;
  authorName: Scalars['String'];
  authors?: Maybe<Array<IdeaAuthor>>;
  blocked?: Maybe<Scalars['Boolean']>;
  challenge?: Maybe<Challenge>;
  challengeLanguage?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  comments?: Maybe<Array<IdeaComment>>;
  committee?: Maybe<Committee>;
  conclusion?: Maybe<IdeaConclusion>;
  contactHour?: Maybe<Scalars['String']>;
  costCenter?: Maybe<Scalars['String']>;
  country?: Maybe<Country>;
  countryId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  document: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  endedAction?: Maybe<Scalars['Int']>;
  expectations?: Maybe<Array<IdeaExpectation>>;
  father?: Maybe<Idea>;
  financeValue?: Scalars['Float'];
  id: Scalars['ID'];
  ideafiles?: Maybe<Array<IdeaFile>>;
  implementationResume?: Maybe<Scalars['String']>;
  keyWords?: Maybe<Scalars['String']>;
  likes?: Scalars['Float'];
  managerName?: Maybe<Scalars['String']>;
  motive?: Maybe<Scalars['String']>;
  nameCode?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneExtensionLine?: Maybe<Scalars['String']>;
  premiationDate?: Maybe<Scalars['DateTime']>;
  productiveDescription?: Maybe<Scalars['String']>;
  productiveEquipament?: Scalars['Boolean'];
  productivityValueHH?: Scalars['Float'];
  productivityValueHM?: Scalars['Float'];
  re: Scalars['String'];
  resumeIdea?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  short?: Maybe<Scalars['String']>;
  sons?: Maybe<Array<Idea>>;
  status?: Scalars['String'];
  statusOrder?: Maybe<Scalars['Float']>;
  statusUser?: Scalars['String'];
  sustainabilities?: Maybe<Sustainability[]>;
  sustentabilityPoint?: Scalars['Float'];
  sustentabilityType?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<IdeaTag>>;
  title: Scalars['String'];
  turn?: Maybe<Scalars['String']>;
  unity?: Maybe<Unity>;
  updatedAt?: Scalars['DateTime'];
  currentProblem?: Scalars['String'];
  problemSolution?: Scalars['String'];
  challengeType?: Maybe<Scalars['String']>;
};

/** Entity Idea Author Object */
export class IdeaAuthor {
  area?: Maybe<Scalars['String']>;
  costCenter?: Maybe<Scalars['String']>;
  cpf?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idea: Idea;
  jobRole?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  remove?: Maybe<Scalars['Boolean']>;
  re: Scalars['String'];
};

/** Entity Idea Comment Object */
export class IdeaComment {
  createdAt: Scalars['DateTime'];
  deletedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  message: Scalars['String'];
  name: Scalars['String'];
  /** Enum approved|denied|pending */
  status: Scalars['String'];
};

export class IdeaConclusion {
  createdAt: Scalars['DateTime'];
  financialVote: Scalars['String'];
  financialVoteDescription?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idea: Idea;
  points: Scalars['Float'];
  prize: Scalars['Float'];
  productivityVote: Scalars['String'];
  productivityVoteDescription?: Maybe<Scalars['String']>;
  sustainabilityVote: Scalars['String'];
  sustainabilityVoteDescription?: Maybe<Scalars['String']>;
};

/** Entity Idea Author Object */
export class IdeaExpectation {
  challengeLanguage?: Maybe<Scalars['String']>;
  expectation: Scalars['String'];
  expectationDescription: Scalars['String'];
  id: Scalars['ID'];
  idea: Idea;
  isSelected: Scalars['Boolean'];
};

export class IdeaFile {
  file?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  idea?: Maybe<Idea>;
};

export class IdeaPage {
  currentPage: Scalars['Int'];
  ideas: Array<Idea>;
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previouPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class IdeaTag {
  id: Scalars['String'];
  idea: Idea;
  tag: Scalars['String'];
};

export class Kamban {
  cards?: Maybe<Array<ActionKamban>>;
  name: Scalars['String'];
};

export class Mutation {
  acceptIdea: Idea;
  /** Add one like to an idea */
  addLike: Scalars['Float'];
  /** Add tags to News */
  addNewsTags: News;
  approvedIdea: Idea;
  awardIdea: Idea;
  createAction: Action;
  createActionComment: ActionComment;
  createActionTask: ActionTask;
  createArea: Area;
  /** Create a new Challenge */
  createChallenge: Challenge;
  createCommittee: Committee;
  /** Create a new Country */
  createCountry: Country;
  /** Create a new Idea */
  createIdea: Idea;
  /** Create a new Comment in Idea */
  createIdeaComment: IdeaComment;
  createIdeaConclusion: IdeaConclusion;
  /** Create new news */
  createNews: News;
  createNotification: Notification;
  /** Create new tag */
  createTag: NewsTag;
  /** Create a new Unity */
  createUnity: Unity;
  /** Create new User */
  createUser: User;
  denyIdea: Idea;
  login: AuthType;
  readNotification: Notification;
  removeAction: DefaultMessage;
  removeActionFile: DefaultMessage;
  removeActionTask: DefaultMessage;
  removeArea: DefaultMessage;
  /** Remove a Challenge By ID */
  removeChallenge: DefaultMessage;
  removeCommittee: DefaultMessage;
  /** Remove Country By ID */
  removeCountry: Country;
  removeFile: DefaultMessage;
  /** Remove a Idea by ID */
  removeIdea: DefaultMessage;
  /** Remove news by id */
  removeNews: DefaultMessage;
  removeNotification: DefaultMessage;
  /** Remove tag by id */
  removeTag: Scalars['Boolean'];
  /** Remove Unity */
  removeUnity: DefaultMessage;
  /** Remove a user by ID */
  removeUser: Scalars['Boolean'];
  reproveIdea: Idea;
  translateIdea: DefaultMessage;
  updateAction: Action;
  updateActionComment: ActionComment;
  updateActionStatus: Action;
  updateActionTaskStatus: ActionTask;
  updateArea: Area;
  /** Update a Challenge */
  updateChallenge: Challenge;
  updateCommittee: Committee;
  /** Update a Idea */
  updateIdea: Idea;
  updateIdeaCommittee: DefaultMessage;
  updateIdeaConclusion: IdeaConclusion;
  updateIdeaImplementation: Idea;
  /** Update news by id */
  updateNews: News;
  updateNotification: Notification;
  /** Update tag by id */
  updateTag: NewsTag;
  /** Update Unity */
  updateUnity: Unity;
  /** Update a User By ID */
  updateUser: User;
};


export class MutationAcceptIdeaArgs {
  data: AcceptIdeaInput;
};


export class MutationAddLikeArgs {
  id: Scalars['String'];
};


export class MutationAddNewsTagsArgs {
  id: Scalars['ID'];
  tag: Array<Scalars['String']>;
};


export class MutationApprovedIdeaArgs {
  data: ApproveIdeaInput;
};


export class MutationAwardIdeaArgs {
  id: Scalars['String'];
};


export class MutationCreateActionArgs {
  data: CreateActionInput;
};


export class MutationCreateActionCommentArgs {
  data: CreateActionCommentInput;
};


export class MutationCreateActionTaskArgs {
  data: CreateActionTaskInput;
};


export class MutationCreateAreaArgs {
  data: CreateAreaInput;
};


export class MutationCreateChallengeArgs {
  data: CreateChallengeInput;
};


export class MutationCreateCommitteeArgs {
  createCommitteeInput: CreateCommitteeInput;
};


export class MutationCreateCountryArgs {
  data: CreateCountryInput;
};


export class MutationCreateIdeaArgs {
  data: CreateIdeaInput;
};


export class MutationCreateIdeaCommentArgs {
  data: CreateIdeaCommentInput;
  id: Scalars['String'];
};


export class MutationCreateIdeaConclusionArgs {
  data: CreateIdeaConclusionInput;
};


export class MutationCreateNewsArgs {
  data: CreateNewsInput;
};


export class MutationCreateNotificationArgs {
  data: CreateNotificationInput;
};


export class MutationCreateTagArgs {
  data: CreateTagInput;
};


export class MutationCreateUnityArgs {
  data: CreateUnityInput;
};


export class MutationCreateUserArgs {
  data: CreateUserInput;
};


export class MutationDenyIdeaArgs {
  id: Scalars['String'];
};


export class MutationLoginArgs {
  data: AuthInput;
};


export class MutationReadNotificationArgs {
  id: Scalars['String'];
};


export class MutationRemoveActionArgs {
  id: Scalars['ID'];
};


export class MutationRemoveActionFileArgs {
  id: Scalars['ID'];
};


export class MutationRemoveActionTaskArgs {
  id: Scalars['ID'];
};


export class MutationRemoveAreaArgs {
  id: Scalars['ID'];
};


export class MutationRemoveChallengeArgs {
  id: Scalars['String'];
  language: Scalars['String'];
};


export class MutationRemoveCommitteeArgs {
  id: Scalars['ID'];
};


export class MutationRemoveCountryArgs {
  id: Scalars['String'];
};


export class MutationRemoveFileArgs {
  id: Scalars['String'];
};


export class MutationRemoveIdeaArgs {
  id: Scalars['ID'];
};


export class MutationRemoveNewsArgs {
  id: Scalars['String'];
};


export class MutationRemoveNotificationArgs {
  id: Scalars['String'];
};


export class MutationRemoveTagArgs {
  id: Scalars['ID'];
};


export class MutationRemoveUnityArgs {
  id: Scalars['String'];
};


export class MutationRemoveUserArgs {
  id: Scalars['String'];
};


export class MutationReproveIdeaArgs {
  data: ReproveIdeaInput;
};


export class MutationTranslateIdeaArgs {
  data: Array<TranslateIdeaInput>;
};


export class MutationUpdateActionArgs {
  data: UpdateActionInput;
};


export class MutationUpdateActionCommentArgs {
  data: UpdateActionCommentInput;
};


export class MutationUpdateActionStatusArgs {
  id: Scalars['ID'];
  status: Scalars['String'];
};


export class MutationUpdateActionTaskStatusArgs {
  id: Scalars['ID'];
};


export class MutationUpdateAreaArgs {
  data: UpdateAreaInput;
};


export class MutationUpdateChallengeArgs {
  data: UpdateChallengeInput;
  language: Scalars['String'];
};


export class MutationUpdateCommitteeArgs {
  data: UpdateCommitteeInput;
};


export class MutationUpdateIdeaArgs {
  data: UpdateIdeaInput;
};


export class MutationUpdateIdeaCommitteeArgs {
  data: UpdateIdeaCommitteeInput;
};

export class MutationUpdateIdeaCodeArgs {
  data: UpdateIdeaCodeInput;
};

export class MutationUpdateIdeaStatusArgs {
  data: UpdateIdeaStatusInput;
};

export class MutationUpdateIdeaConclusionArgs {
  data: UpdateIdeaConclusionInput;
};


export class MutationUpdateIdeaImplementationArgs {
  data: UpdateIdeaImplementationInput;
};


export class MutationUpdateNewsArgs {
  data: UpdateNewsInput;
};


export class MutationUpdateNotificationArgs {
  data: UpdateNotificationInput;
};


export class MutationUpdateTagArgs {
  data: UpdateTagInput;
};


export class MutationUpdateUnityArgs {
  data: UpdateUnityInput;
};


export class MutationUpdateUserArgs {
  data: UpdateUserInput;
  id: Scalars['String'];
};

/** Entity News Object */
export class News {
  author: Scalars['String'];
  content: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  id: Scalars['ID'];
  imageUrl?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  status: Scalars['String'];
  tags?: Maybe<Array<NewsTag>>;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export class NewsPage {
  currentPage: Scalars['Int'];
  news: Array<News>;
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previouPage: Scalars['Boolean'];
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

/** Entity Tags Object */
export class NewsTag {
  id: Scalars['ID'];
  news: News;
  tag: Scalars['String'];
};

export class Notification {
  date: Scalars['DateTime'];
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  message: Scalars['String'];
  relationId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: Scalars['String'];
  user?: Maybe<User>;
};

export class NotificationUserInput {
  id: Scalars['String'];
};

export class PageChallenge {
  currentPage: Scalars['Int'];
  nextPage: Scalars['Boolean'];
  pageSize: Scalars['Int'];
  previouPage: Scalars['Boolean'];
  results: Array<Challenge>;
  totalCount: Scalars['Int'];
  totalPage: Scalars['Int'];
};

export class Query {
  /** Return All Unities by user role */
  UnitiesByUser: Array<Unity>;
  action: Action;
  actionHistory: ActionHistoryPage;
  actionKamban: Array<Kamban>;
  actionStatus: Array<Scalars['String']>;
  actions: Array<Action>;
  area: Area;
  areas: Array<Area>;
  codes: Array<Scalars['String']>;
  committee: Committee;
  committees: Array<Committee>;
  /** Return All Ideas By Keyword */
  getAllIdeas: Array<Idea>;
  /** Return All Authors */
  getAuthors: Array<Idea>;
  /** Find a Challenge By ID */
  getChallenge: Challenge;
  /** Return all Challenges */
  getChallenges: Array<Challenge>;
  /** Return all Challenges of set language */
  getChallengesByLanguage: Array<Challenge>;
  /** Return all Challenges of set language */
  getChallengesByLanguageAll: Array<Challenge>;
  /** Return All Countries */
  getCountries: Array<Country>;
  /** Get Country By ID */
  getCountry: Country;
  /** Return Dashboard Home */
  getDashboardHome: DashboardHome;
  /** Return Idea by ID */
  getIdea: Idea;
  /** Return All Ideas */
  getIdeas: Array<Idea>;
  /** Return All Ideas By Keyword */
  getIdeasSearch: Array<Idea>;
  /** Return news by id */
  getNew: News;
  /** List all news */
  getNews: Array<News>;
  /** List all news by Keyword */
  getNewsSearch: NewsPage;
  /** Return tag by id */
  getTag: NewsTag;
  /** List all tags */
  getTags: Array<NewsTag>;
  /** Return All Unities */
  getUnities: Array<Unity>;
  /** Return All Unities By CountryId */
  getUnitiesByCountry: Array<Unity>;
  /** Get Unity By ID */
  getUnity: Unity;
  /** Return a User by ID */
  getUser: User;
  /** Return a User by Email */
  getUserByEmail: User;
  /** Return All Users */
  getUsers: Array<User>;
  home: Home;
  ideaByStatus: Array<Idea>;
  /** Current User */
  me: User;
  notification: Notification;
  notifications: Array<Notification>;
  notificationsByUser: UserNotificationDto;
  pageChallenges: PageChallenge;
  searchAction: Array<Kamban>;
  /** Search for admin */
  searchAllIdeas: IdeaPage;
  searchArea: Array<Area>;
  searchCommittee: Array<Committee>;
  searchUnity: Array<Unity>;
  searchUser: Array<User>;
  sustainabilities: Array<Sustainability>;
  validateApproveIdea: DefaultMessage;
};


export class QueryActionArgs {
  id: Scalars['ID'];
};


export class QueryActionHistoryArgs {
  id: Scalars['String'];
  page?: InputMaybe<Scalars['Float']>;
};


export class QueryActionKambanArgs {
  id: Scalars['ID'];
};


export class QueryAreaArgs {
  id: Scalars['ID'];
};


export class QueryCommitteeArgs {
  id: Scalars['ID'];
};


export class QueryGetAllIdeasArgs {
  keyword?: InputMaybe<Scalars['String']>;
};


export class QueryGetChallengeArgs {
  id: Scalars['String'];
  language: Scalars['String'];
};


export class QueryGetChallengesByLanguageArgs {
  language: Scalars['String'];
};


export class QueryGetChallengesByLanguageAllArgs {
  language: Scalars['String'];
};


export class QueryGetCountryArgs {
  id: Scalars['String'];
};


export class QueryGetIdeaArgs {
  id: Scalars['String'];
};


export class QueryGetIdeasSearchArgs {
  data: SearchIdeaInput;
};


export class QueryGetNewArgs {
  id: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
};


export class QueryGetNewsSearchArgs {
  keyword: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export class QueryGetTagArgs {
  id: Scalars['ID'];
};


export class QueryGetUnitiesByCountryArgs {
  id: Scalars['String'];
};


export class QueryGetUnityArgs {
  id: Scalars['String'];
};


export class QueryGetUserArgs {
  id: Scalars['String'];
};


export class QueryGetUserByEmailArgs {
  email: Scalars['String'];
};


export class QueryHomeArgs {
  page?: InputMaybe<Scalars['Float']>;
};


export class QueryIdeaByStatusArgs {
  status: Array<Scalars['String']>;
};


export class QueryNotificationArgs {
  id: Scalars['String'];
};


export class QueryPageChallengesArgs {
  filter: SearchChallengeInput;
};


export class QuerySearchActionArgs {
  data: SearchActionInput;
};


export class QuerySearchAllIdeasArgs {
  data: SearchIdeaInput;
};


export class QuerySearchAreaArgs {
  data: SearchAreaInput;
};


export class QuerySearchCommitteeArgs {
  data: SearchCommittee;
};


export class QuerySearchUnityArgs {
  data: SearchUnityInput;
};


export class QuerySearchUserArgs {
  data: SearchUserInput;
};


export class QueryValidateApproveIdeaArgs {
  id: Scalars['String'];
};

export class ReproveIdeaInput {
  id: Scalars['ID'];
  motive: Scalars['String'];
  userId?: Scalars['String'];
};

export class SearchActionInput {
  committee?: InputMaybe<Array<Scalars['String']>>;
  country?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  idea?: InputMaybe<Scalars['String']>;
  isDelayed?: InputMaybe<Scalars['Boolean']>;
  keyword?: InputMaybe<Scalars['String']>;
  responsible?: InputMaybe<Array<Scalars['String']>>;
  start?: InputMaybe<Scalars['DateTime']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchAreaInput {
  keyword?: InputMaybe<Scalars['String']>;
};

export class SearchPurchasesExchangesInput {
  keyword?: InputMaybe<Scalars['String']>;
};

export class SearchFrameInput {
  keyword?: InputMaybe<Scalars['String']>;
};

export class SearchChallengeInput {
  keyword?: InputMaybe<Scalars['String']>;
  /** enum "pt-BR"|"es-ES" */
  language?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
};

export class SearchCommittee {
  area?: InputMaybe<Scalars['String']>;
  frames?: InputMaybe<CreateFrameInput[]>;
  kaizen: Scalars['Boolean'];
  keyword?: InputMaybe<Scalars['String']>;
  manager?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Boolean']>;
  unity?: InputMaybe<Scalars['String']>;
};

export class SearchIdeaInput {
  authorName?: InputMaybe<Array<Scalars['String']>>;
  committeeId?: InputMaybe<Array<Scalars['String']>>;
  frame?: InputMaybe<Scalars['String']>;
  countryId?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['DateTime']>;
  keyword?: InputMaybe<Scalars['String']>;
  /** Enum name|createdAt */
  order?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  unityId?: InputMaybe<Scalars['String']>;
  challengeName?: InputMaybe<Array<Scalars['String']>>;
};

export class SearchUnityInput {
  country?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
};

export class SearchUserInput {
  committee?: InputMaybe<Scalars['String']>;
  keyword?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<Scalars['String']>;
  currentPage?: InputMaybe<Scalars['Int']>;
  totalPage?: InputMaybe<Scalars['Int']>;
};

export class SustainabilityKaizen {
  id: Scalars['ID'];
  ideasKaizen?: Maybe<IdeaKaizen[]>;
  type?: Maybe<Scalars['String']>;
};

export class TranslateIdeaChallengeInput {
  id: Scalars['String'];
};

export class TranslateIdeaExpectationInput {
  expectation: Scalars['String'];
  expectationDescription: Scalars['String'];
  id: Scalars['String'];
};

export class TranslateIdeaInput {
  analysisDescription?: InputMaybe<Scalars['String']>;
  challengeId: TranslateIdeaChallengeInput;
  /** Enum: 'pt-BR'|'es-ES' */
  challengeLanguage: Scalars['String'];
  description: Scalars['String'];
  expectation?: InputMaybe<Array<TranslateIdeaExpectationInput>>;
  id: Scalars['ID'];
  motive?: InputMaybe<Scalars['String']>;
  productiveDescription?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  implementationResume?: Scalars['String'];
};

export class Unity {
  committee?: Maybe<Array<Committee>>;
  country?: Maybe<Country>;
  id: Scalars['ID'];
  idea?: Maybe<Array<Idea>>;
  name: Scalars['String'];
  user?: Maybe<Array<User>>;
};

export class UpdateActionCommentInput {
  comment: Scalars['String'];
  id: Scalars['ID'];
};

export class UpdateActionInput {
  description?: InputMaybe<Scalars['String']>;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  idea?: InputMaybe<CreateActionIdeaInput>;
  ideaId?: InputMaybe<Scalars['String']>;
  responsible?: InputMaybe<CreateActionResponsibleInput>;
  responsibleId?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** Enum pending|in progress|done|canceled */
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export class UpdateAreaInput {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Object update challenge */
export class UpdateChallengeInput {
  id: Scalars['String'];
  type: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;

  endDate?: InputMaybe<Scalars['DateTime']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
  isDateSensitive?: InputMaybe<Scalars['Boolean']>;
};

export class UpdateCommitteeInput {
  area?: InputMaybe<CreateCommitteeAreaInput>;
  id?: InputMaybe<Scalars['ID']>;
  manager?: InputMaybe<CreateCommitteeManagerInput>;
  name?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Array<CreateCommitteeParticipantInput>>;
  frames?: InputMaybe<CreateFrameInput[]>;
  status?: InputMaybe<Scalars['Boolean']>;
  kaizen?: InputMaybe<Scalars['Boolean']>;
  unity?: InputMaybe<CreateCommitteeUnityInput>;
};

export class UpdateIdeaCommitteeInput {
  committe: BaseInput;
  id: Scalars['String'];
};

export class UpdateIdeaCodeInput {
  code: Scalars['String'];
  id: Scalars['String'];
};

export class UpdateIdeaStatusInput {
  status: Scalars['String'];
  id: Scalars['String'];
};

export class UpdateIdeaConclusionInput {
  /** enum not attend|parctially attends|attend|overcomes */
  financialVote?: InputMaybe<Scalars['String']>;
  financialVoteDescription?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  idea?: InputMaybe<CreateIdeaConclusionIdeaInput>;
  points?: InputMaybe<Scalars['Float']>;
  /** decimal(10,2) */
  prize?: InputMaybe<Scalars['Float']>;
  /** enum not attend|parctially attends|attend|overcomes */
  productivityVote?: InputMaybe<Scalars['String']>;
  productivityVoteDescription?: InputMaybe<Scalars['String']>;
  /** enum not attend|parctially attends|attend|overcomes */
  sustainabilityVote?: InputMaybe<Scalars['String']>;
  sustainabilityVoteDescription?: InputMaybe<Scalars['String']>;
};

export class UpdateIdeaImplementationInput {
  analysisDescription?: InputMaybe<Scalars['String']>;
  /** decimal(10,2) */
  analysisFinacialreturn?: InputMaybe<Scalars['Float']>;
  /** decimal(10,2) */
  analysisMachineValue?: InputMaybe<Scalars['Float']>;
    /** decimal(10,2) */
  productivityValueHH?: InputMaybe<Scalars['Float']>;
  /** decimal(10,2) */
  sustentabilityPoint?: InputMaybe<Scalars['Float']>;
  /** decimal(10,2) */
  analysisManValue?: InputMaybe<Scalars['Float']>;
  /** enum water|energy|waste */
  analysisSustainability?: InputMaybe<Scalars['String']>;
  expectations?: InputMaybe<Array<ApproveIdeaExpectationsInput>>;
  id: Scalars['ID'];
  implementationResume: Scalars['String'];
  premiationDate: Scalars['DateTime'];
  sustainability?: InputMaybe<Array<ApproveIdeaSustainabilityInput>>;
  authorName?: InputMaybe<Scalars['String']>;
  re?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
};

export class UpdateIdeaInput {
  areaExtensionLine?: InputMaybe<Scalars['String']>;
  areaResponsible?: InputMaybe<Scalars['String']>;
  authorName?: InputMaybe<Scalars['String']>;
  authors?: InputMaybe<Array<CreateIdeaAuthorInput>>;
  challenge?: InputMaybe<CreateIdeaChallengeInput>;
  contactHour?: InputMaybe<Scalars['String']>;
  costCenter?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CreateIdeaCountryInput>;
  description?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  expectation?: InputMaybe<Array<CreateIdeaExpectationInput>>;
  id: Scalars['String'];
  managerName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneExtensionLine?: InputMaybe<Scalars['String']>;
  productiveDescription?: InputMaybe<Scalars['String']>;
  productiveEquipament?: InputMaybe<Scalars['Boolean']>;
  re?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  turn?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<CreateIdeaUnityInput>;
  ideaKaizenId?: Scalars['String'];
  status?: InputMaybe<Scalars['String']>
  analysisFinacialreturn?: InputMaybe<Scalars['Float']>
  productivityValueHH?: InputMaybe<Scalars['Float']>
  sustentabilityPoint?: InputMaybe<Scalars['Float']>
  premiationDate?: InputMaybe<Scalars['DateTime']>
};

export class UpdateNewsInput {
  author?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /** Enum "published"|"unpublished" */
  status?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Array<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
};

export class UpdateNotificationInput {
  additionalParticipants?: InputMaybe<Scalars['String']>;
  applicant?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  ideaTitle?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  re?: InputMaybe<Scalars['String']>;
  relationId?: InputMaybe<Scalars['String']>;
  subject?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<NotificationUserInput>;
};

export class UpdateTagInput {
  id: Scalars['String'];
  tag?: InputMaybe<Scalars['String']>;
};

export class UpdateUnityInput {
  country?: InputMaybe<CreateUnityCountryInput>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export class UpdateUserInput {
  commites: Array<CreateUserCommitteeInput>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  unity?: InputMaybe<UpdateUserUnityInput>;
  re?: InputMaybe<Scalars['String']>;
};

export class UpdateUserUnityInput {
  id: Scalars['String'];
};

export class User {
  action?: Maybe<Array<Action>>;
  actionHistory?: Maybe<Array<ActionHistory>>;
  comments?: Maybe<Array<ActionComment>>;
  committeeManager?: Maybe<Array<Committee>>;
  committeeParticipants?: Maybe<Array<Committee>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  notification?: Maybe<Array<Notification>>;
  photo?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  unity?: Maybe<Unity>;
  employee?: {
    re: Scalars['String'];
  };
  re: Scalars['String'];
};

export class UserNotificationDto {
  notifications: Array<Notification>;
  total: Scalars['Int'];
  unread: Scalars['Int'];
};

export type UserFragment = { id: string, name: string, email: string, photo?: string | null, role: string };

export type IdeaFragment = { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null };

export type IdeaConclusionFragment = { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null };

export type IdeaExpectationFragment = { id: string, expectation: string, expectationDescription: string };

export type ChallengeFragment = { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null };

export type UnityFragment = { id: string, name: string, country?: { id: string, name: string, flag: string } | null };

export type CommitteeFragment = { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null };

export type NewsFragment = { id: string, createdAt: any, updatedAt: any, title: string, description: string, content: string, author: string, status: string, imageUrl?: string | null, tags?: Array<{ id: string, tag: string }> | null };

export type AreaFragment = { id: string, name: string, committee?: Array<{ id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null }> | null };

export type CountryFragment = { id: string, name: string, flag: string };

export type ActionFragment = { id: string, code: string, title: string, description: string, status: string, startDate: any, endDate: any, createdAt: any, updatedAt: any, files?: Array<{ id: string, url?: string | null, name?: string | null }> | null, responsible?: { id: string, name: string, email: string, role: string, photo?: string | null } | null, idea?: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } | null, history?: Array<{ id: string, after?: string | null, before?: string | null, createdAt: any, type: string, action?: { code: string } | null, user?: { name: string } | null }> | null, tasks?: Array<{ id: string, status: boolean, description: string }> | null, comments?: Array<{ id: string, comment: string, createdAt: any, user?: { id: string, name: string, email: string, photo?: string | null, role: string } | null }> | null };

export type ActionCommentFragment = { id: string, comment: string, createdAt: any, user?: { id: string, name: string, email: string, photo?: string | null, role: string } | null };

export type ActionTaskFragment = { id: string, status: boolean, description: string };

export type DefaultMessageFragment = { message: string, status: number };

export type KambanFragment = { name: string, cards?: Array<{ commentsCount: number, doneTasks: number, filesCount: number, totalTasks: number, isDelayed: boolean, action: { id: string, code: string, title: string, description: string, status: string, startDate: any, endDate: any, createdAt: any, updatedAt: any, files?: Array<{ id: string, url?: string | null, name?: string | null }> | null, responsible?: { id: string, name: string, email: string, role: string, photo?: string | null } | null, idea?: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } | null, history?: Array<{ id: string, after?: string | null, before?: string | null, createdAt: any, type: string, action?: { code: string } | null, user?: { name: string } | null }> | null, tasks?: Array<{ id: string, status: boolean, description: string }> | null, comments?: Array<{ id: string, comment: string, createdAt: any, user?: { id: string, name: string, email: string, photo?: string | null, role: string } | null }> | null } }> | null };

export type ActionKambanFragment = { commentsCount: number, doneTasks: number, filesCount: number, totalTasks: number, isDelayed: boolean, action: { id: string, code: string, title: string, description: string, status: string, startDate: any, endDate: any, createdAt: any, updatedAt: any, files?: Array<{ id: string, url?: string | null, name?: string | null }> | null, responsible?: { id: string, name: string, email: string, role: string, photo?: string | null } | null, idea?: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } | null, history?: Array<{ id: string, after?: string | null, before?: string | null, createdAt: any, type: string, action?: { code: string } | null, user?: { name: string } | null }> | null, tasks?: Array<{ id: string, status: boolean, description: string }> | null, comments?: Array<{ id: string, comment: string, createdAt: any, user?: { id: string, name: string, email: string, photo?: string | null, role: string } | null }> | null } };

export type HomeFragment = { tasksCanceled: number, tasksDone: number, tasksInProgress: number, tasksPending: number, pageSize: number, currentPage: number, nextPage: boolean, previouPage: boolean, totalCount: number, ideas: Array<{ id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null }> };

export type IdeaPageFragment = { currentPage: number, nextPage: boolean, pageSize: number, previouPage: boolean, totalCount: number, totalPage: number, ideas: Array<{ id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null }> };

export type NewsPageFragment = { currentPage: number, nextPage: boolean, pageSize: number, previouPage: boolean, totalCount: number, totalPage: number, news: Array<{ id: string, createdAt: any, updatedAt: any, title: string, description: string, content: string, author: string, status: string, imageUrl?: string | null, tags?: Array<{ id: string, tag: string }> | null }> };

export type PageChallengeFragment = { currentPage: number, nextPage: boolean, pageSize: number, previouPage: boolean, totalCount: number, totalPage: number, results: Array<{ id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null }> };

export type SearchActionQueryVariables = Exact<{
  input: SearchActionInput;
}>;


export type SearchActionQuery = { searchAction: Array<{ name: string, cards?: Array<{ commentsCount: number, doneTasks: number, filesCount: number, totalTasks: number, isDelayed: boolean, action: { id: string, code: string, title: string, description: string, status: string, startDate: any, endDate: any, createdAt: any, updatedAt: any, files?: Array<{ id: string, url?: string | null, name?: string | null, fileName: string }> | null, responsible?: { id: string, name: string, email: string, role: string, photo?: string | null } | null, idea?: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } | null, history?: Array<{ id: string, after?: string | null, before?: string | null, createdAt: any, type: string, action?: { code: string } | null, user?: { name: string } | null }> | null, tasks?: Array<{ id: string, status: boolean, description: string }> | null, comments?: Array<{ id: string, comment: string, createdAt: any, user?: { id: string, name: string, email: string, photo?: string | null, role: string } | null }> | null } }> | null }> };

export type SearchActionHistoryQueryVariables = Exact<{
  id: Scalars['String'];
  page: Scalars['Float'];
}>;


export type SearchActionHistoryQuery = { actionHistory: { currentPage: number, nextPage: boolean, pageSize: number, previouPage: boolean, totalCount: number, totalPage: number, history: Array<{ changedData: string, after?: string | null, before?: string | null, createdAt: any, id: string, type: string, user?: { name: string } | null, action?: { history?: Array<{ user?: { name: string } | null }> | null } | null }> } };

export type UpdateActionStatusMutationVariables = Exact<{
  id: Scalars['ID'];
  status: Scalars['String'];
}>;


export type UpdateActionStatusMutation = { updateActionStatus: { id: string, code: string, title: string, description: string, status: string, startDate: any, endDate: any, createdAt: any, updatedAt: any, files?: Array<{ id: string, url?: string | null, name?: string | null }> | null, responsible?: { id: string, name: string, email: string, role: string, photo?: string | null } | null, idea?: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } | null, history?: Array<{ id: string, after?: string | null, before?: string | null, createdAt: any, type: string, action?: { code: string } | null, user?: { name: string } | null }> | null, tasks?: Array<{ id: string, status: boolean, description: string }> | null, comments?: Array<{ id: string, comment: string, createdAt: any, user?: { id: string, name: string, email: string, photo?: string | null, role: string } | null }> | null } };

export type CreateActionMutationVariables = Exact<{
  input: CreateActionInput;
}>;


export type CreateActionMutation = { createAction: { id: string } };

export type GetActionByIdQuery = { action: { tasks: ActionTask[] } };

export type GetActionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type UpdateActionMutationVariables = Exact<{
  input: UpdateActionInput;
}>;


export type UpdateActionMutation = { updateAction: { id: string } };

export type CreateActionCommentMutationVariables = Exact<{
  input: CreateActionCommentInput;
}>;


export type CreateActionCommentMutation = { createActionComment: { id: string, comment: string, createdAt: any, user?: { id: string, name: string, email: string, photo?: string | null, role: string } | null } };

export type CreateActionTaskMutationVariables = Exact<{
  input: CreateActionTaskInput;
}>;


export type CreateActionTaskMutation = { createActionTask: { id: string, status: boolean, description: string , createdAt: string } };

export type UpdateActionTaskStatusMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type UpdateActionTaskStatusMutation = { updateActionTaskStatus: { id: string, status: boolean, description: string } };

export type RemoveActionTaskMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveActionTaskMutation = { removeActionTask: { message: string, status: number } };

export type RemoveActionFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveActionFileMutation = { removeActionFile: { message: string, status: number } };

export type ActionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionStatusQuery = { actionStatus: Array<string> };

export type SearchAreaQueryVariables = Exact<{
  input: SearchAreaInput;
}>;


export type SearchAreaQuery = { searchArea: Array<{ id: string, name: string, committee?: Array<{ id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null }> | null }> };

export type AreasQueryVariables = Exact<{ [key: string]: never; }>;


export type AreasQuery = { areas: Array<{ id: string, name: string, committee?: Array<{ id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null }> | null }> };

export type CreateAreaMutationVariables = Exact<{
  input: CreateAreaInput;
}>;


export type CreateAreaMutation = { createArea: { id: string, name: string, committee?: Array<{ id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null }> | null } };

export type UpdateAreaMutationVariables = Exact<{
  input: UpdateAreaInput;
}>;


export type UpdateAreaMutation = { updateArea: { id: string, name: string, committee?: Array<{ id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null }> | null } };

export type RemoveAreaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveAreaMutation = { removeArea: { message: string, status: number } };

export type PageChallengesQueryVariables = Exact<{
  data: SearchChallengeInput;
}>;


export type PageChallengesQuery = { pageChallenges: { currentPage: number, nextPage: boolean, pageSize: number, previouPage: boolean, totalCount: number, totalPage: number, results: Array<{ id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null }> } };

export type CreateChallengeMutationVariables = Exact<{
  data: CreateChallengeInput;
}>;


export type CreateChallengeMutation = { createChallenge: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } };

export type UpdateChallengeMutationVariables = Exact<{
  language: Scalars['String'];
  data: UpdateChallengeInput;
}>;


export type UpdateChallengeMutation = { updateChallenge: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } };

export type RemoveChallengeMutationVariables = Exact<{
  language: Scalars['String'];
  id: Scalars['String'];
}>;


export type RemoveChallengeMutation = { removeChallenge: { message: string, status: number } };

export type CommitteesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommitteesQuery = { committees: Array<{ id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null }> };

export type GetIdeaCommiteeByIdQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetIdeaCommiteeByIdQuery = { getIdea: { id: string, committee?: { id: string, participants?: Array<{ id: string, name: string }> | null } | null } };

export type SearchCommitteeQueryVariables = Exact<{
  input: SearchCommittee;
}>;


export type SearchCommitteeQuery = { searchCommittee: Array<{ id: string, name: string, kaizen: boolean, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null }> };

export type CreateCommitteeMutationVariables = Exact<{
  input: CreateCommitteeInput;
}>;


export type CreateCommitteeMutation = { createCommittee: { id: string } };

export type UpdateCommitteeMutationVariables = Exact<{
  input: UpdateCommitteeInput;
}>;


export type UpdateCommitteeMutation = { updateCommittee: { id: string } };

export type RemoveCommitteeMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveCommitteeMutation = { removeCommittee: { message: string, status: number } };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { getCountries: Array<{ id: string, name: string, flag: string }> };

export type HomeQueryVariables = Exact<{
  page: Scalars['Float'];
}>;


export type HomeQuery = { home: { tasksCanceled: number, tasksDone: number, tasksInProgress: number, tasksPending: number, pageSize: number, currentPage: number, nextPage: boolean, previouPage: boolean, totalCount: number, ideas: Array<{ id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null }> } };

export type SearchAllIdeasQueryVariables = Exact<{
  input: SearchIdeaInput;
}>;


export type SearchAllIdeasQuery = { searchAllIdeas: { currentPage: number, nextPage: boolean, pageSize: number, previouPage: boolean, totalCount: number, totalPage: number, ideas: Array<{ id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null }> } };

export type GetIdeaQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetIdeaQuery = { getIdea: { id: string, status: string, title: string, currentProblem: string, problemSolution: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } };

export type GetIdeasQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdeasQuery = { getIdeas: Array<{ id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null }> };

export type GetAuthorsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthorsQuery = { getAuthors: Array<{ authorName: string }> };

export type IdeaByStatusQueryVariables = Exact<{
  status: Array<Scalars['String']> | Scalars['String'];
}>;


export type IdeaByStatusQuery = { ideaByStatus: Array<{ id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null }> };

export type ValidateApproveQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ValidateApproveQuery = { validateApproveIdea: { message: string, status: number } };

export type AcceptIdeaMutationVariables = Exact<{
  input: AcceptIdeaInput;
}>;


export type AcceptIdeaMutation = { acceptIdea: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } };

export type ApprovedIdeaMutationVariables = Exact<{
  input: ApproveIdeaInput;
}>;


export type ApprovedIdeaMutation = { approvedIdea: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } };

export type CreateIdeaConclusionMutationVariables = Exact<{
  input: CreateIdeaConclusionInput;
}>;


export type CreateIdeaConclusionMutation = { createIdeaConclusion: { id: string } };

export type UpdateIdeaConclusionMutationVariables = Exact<{
  input: UpdateIdeaConclusionInput;
}>;


export type UpdateIdeaConclusionMutation = { updateIdeaConclusion: { id: string } };

export type AwardIdeaMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type AwardIdeaMutation = { awardIdea: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } };

export type UpdateIdeaImplementationMutationVariables = Exact<{
  input: UpdateIdeaImplementationInput;
}>;


export type UpdateIdeaImplementationMutation = { updateIdeaImplementation: { id: string } };

export type ReproveIdeaMutationVariables = Exact<{
  input: ReproveIdeaInput;
}>;


export type ReproveIdeaMutation = { reproveIdea: { id: string } };

export type RemoveFileMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveFileMutation = { removeFile: { message: string, status: number } };

export type TranslateIdeaMutationVariables = Exact<{
  input: Array<TranslateIdeaInput> | TranslateIdeaInput;
}>;


export type TranslateIdeaMutation = { translateIdea: { message: string, status: number } };

export type GetChallengesByLanguageAllQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetChallengesByLanguageAllQuery = { getChallengesByLanguageAll: Array<{ createdAt: any, deletedAt?: any | null, description: string, endDate?: any | null, id: string, isDateSensitive?: boolean | null, language: string, name: string, startDate?: any | null, status: string, title: string, updatedAt: any }> };

export type DenyIdeaMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DenyIdeaMutation = { denyIdea: { id: string, status: string, title: string, code?: string | null, nameCode?: string | null, description?: string | null, motive?: string | null, authorName: string, challengeLanguage?: string | null, role?: string | null, re: string, turn?: string | null, managerName?: string | null, phone?: string | null, phoneExtensionLine?: string | null, costCenter?: string | null, contactHour?: string | null, productivityValueHH: number, productivityValueHM: number, analysisFinacialreturn: number, analysisSustainability?: string | null, productiveEquipament: boolean, productiveDescription?: string | null, areaResponsible?: string | null, areaExtensionLine?: string | null, email?: string | null, likes: number, financeValue: number, createdAt: any, updatedAt: any, endedAction?: number | null, blocked?: boolean | null, premiationDate?: any | null, implementationResume?: string | null, analysisManValue: number, analysisMachineValue: number, father?: { status: string } | null, expectations?: Array<{ id: string, challengeLanguage?: string | null, expectation: string, expectationDescription: string }> | null, sons?: Array<{ id: string, title: string, motive?: string | null, description?: string | null, challengeLanguage?: string | null, productiveDescription?: string | null, analysisDescription?: string | null, expectations?: Array<{ isSelected: boolean, id: string, expectationDescription: string, expectation: string, challengeLanguage?: string | null }> | null }> | null, ideafiles?: Array<{ file?: string | null, fileName?: string | null, id: string }> | null, authors?: Array<{ id: string, name: string, re: string, area?: string | null, jobRole?: string | null, cpf?: string | null, email?: string | null, costCenter?: string | null }> | null, tags?: Array<{ id: string, tag: string }> | null, action?: Array<{ id: string, code: string, title: string, description: string, status: string, endDate: any, startDate: any, createdAt: any, updatedAt: any }> | null, unity?: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } | null, challenge?: { id: string, title: string, name: string, description: string, createdAt: any, language: string, status: string, startDate?: any | null, endDate?: any | null, isDateSensitive?: boolean | null } | null, committee?: { id: string, name: string, status: boolean, area?: { id: string, name: string } | null, manager?: { id: string, name: string, photo?: string | null } | null, participants?: Array<{ id: string, name: string, photo?: string | null }> | null, unity?: { name: string, id: string } | null } | null, conclusion?: { id: string, createdAt: any, financialVote: string, prize: number, points: number, productivityVote: string, sustainabilityVote: string, productivityVoteDescription?: string | null, financialVoteDescription?: string | null, sustainabilityVoteDescription?: string | null } | null, sustainability?: Array<{ id: string, type?: string | null }> | null } };

export type UpdateIdeaCommitteeMutationVariables = Exact<{
  input: UpdateIdeaCommitteeInput;
}>;

export type UpdateIdeaCommitteeMutation = { updateIdeaCommittee: { message: string, status: number } };

export type UpdateIdeaCodeMutationVariables = Exact<{
  input: UpdateIdeaCodeInput;
}>;

export type UpdateIdeaCodeMutation = { updateIdeaCode: { message: string, status: number } };

export type UpdateIdeaStatusMutationVariables = Exact<{
  input: UpdateIdeaStatusInput;
}>;

export type UpdateIdeaStatusMutation = { updateIdeaStatus: { message: string, status: number } };

export type RemoveIdeaMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveIdeaMutation = { removeIdea: { message: string, status: number } };

export type GetNewsSearchQueryVariables = Exact<{
  page: Scalars['Int'];
  status: Scalars['String'];
  language: Scalars['String'];
  input: Scalars['String'];
}>;


export type GetNewsSearchQuery = { getNewsSearch: { currentPage: number, nextPage: boolean, pageSize: number, previouPage: boolean, totalCount: number, totalPage: number, news: Array<{ id: string, createdAt: any, updatedAt: any, title: string, description: string, content: string, author: string, status: string, imageUrl?: string | null, tags?: Array<{ id: string, tag: string }> | null }> } };

export type GetNewQueryVariables = Exact<{
  input: Scalars['String'];
}>;


export type GetNewQuery = { getNew: { id: string, createdAt: any, updatedAt: any, title: string, description: string, content: string, author: string, status: string, imageUrl?: string | null, tags?: Array<{ id: string, tag: string }> | null } };

export type CreateNewsMutationVariables = Exact<{
  data: CreateNewsInput;
}>;


export type CreateNewsMutation = { createNews: { id: string, createdAt: any, updatedAt: any, title: string, description: string, content: string, author: string, status: string, imageUrl?: string | null, tags?: Array<{ id: string, tag: string }> | null } };

export type UpdateNewsMutationVariables = Exact<{
  data: UpdateNewsInput;
}>;


export type UpdateNewsMutation = { updateNews: { id: string, createdAt: any, updatedAt: any, title: string, description: string, content: string, author: string, status: string, imageUrl?: string | null, tags?: Array<{ id: string, tag: string }> | null } };

export type RemoveNewsMutationVariables = Exact<{
  input: Scalars['String'];
}>;


export type RemoveNewsMutation = { removeNews: { message: string, status: number } };

export type AddNewsTagsMutationVariables = Exact<{
  input: Array<Scalars['String']> | Scalars['String'];
  id: Scalars['ID'];
}>;


export type AddNewsTagsMutation = { addNewsTags: { id: string, createdAt: any, updatedAt: any, title: string, description: string, content: string, author: string, status: string, imageUrl?: string | null, tags?: Array<{ id: string, tag: string }> | null } };

export type GetUnitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnitiesQuery = { getUnities: Array<{ id: string, name: string, country?: { id: string, name: string, flag: string } | null }> };

export type SearchUnityQueryVariables = Exact<{
  input: SearchUnityInput;
}>;


export type SearchUnityQuery = { searchUnity: Array<{ id: string, name: string, country?: { id: string, name: string, flag: string } | null }> };

export type CreateUnityMutationVariables = Exact<{
  input: CreateUnityInput;
}>;


export type CreateUnityMutation = { createUnity: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } };

export type UpdateUnityMutationVariables = Exact<{
  input: UpdateUnityInput;
}>;


export type UpdateUnityMutation = { updateUnity: { id: string, name: string, country?: { id: string, name: string, flag: string } | null } };

export type RemoveUnityMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveUnityMutation = { removeUnity: { message: string, status: number } };

export type GetUnitiesByCountryQueryVariables = Exact<{
  countryId: Scalars['String'];
}>;


export type GetUnitiesByCountryQuery = { getUnitiesByCountry: Array<{ id: string, name: string, country?: { id: string, name: string, flag: string } | null }> };

export type LoginMutationVariables = Exact<{
  code: Scalars['String'];
  redirectUri: Scalars['String'];
  email: Scalars['String'];
  application: Scalars['String'];
}>;


export type LoginMutation = { login: { token: string, country: string, user: { id: string, name: string, email: string, photo?: string | null, role: string } } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { id: string, name: string, email: string, photo?: string | null, role: string, unity?: { id: string } | null } };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { getUsers: Array<{ id: string, name: string, email: string, photo?: string | null, role: string }> };

export type SearchUserQueryVariables = Exact<{
  input: SearchUserInput;
}>;


export type SearchUserQuery = { searchUser: { results: Array<{ id: string, name: string, email: string, photo?: string | null, role: string, unity?: { id: string, name: string, country?: { id: string, name: string } | null } | null, committeeManager?: Array<{ id: string, name: string }> | null, committeeParticipants?: Array<{ id: string, name: string }> | null }>, currentPage: number, totalPages: number} };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { createUser: { id: string, name: string, email: string, photo?: string | null, role: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
  id: Scalars['String'];
}>;


export type UpdateUserMutation = { updateUser: { id: string, name: string, email: string, photo?: string | null, role: string } };

export type RemoveUserMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveUserMutation = { removeUser: boolean };

export type GetNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationQuery = { notificationsByUser: { total: number, unread: number, notifications: Array<{ id: string, title: string, message: string, type: string, isRead: boolean, relationId?: string | null }> } };

export type ReadNotificationMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReadNotificationMutation = { readNotification: { id: string } };



export const CommitteeFragmentDoc = gql`
    fragment Committee on Committee {
  id
  name
  frames {
    id
    name
  }
  kaizen
  status
  area {
    id
    name
  }
  manager {
    id
    name
    photo
  }
  participants {
    id
    name
    photo
  }
  unity {
    name
    id
  }
}
    `;
export const AreaFragmentDoc = gql`
    fragment Area on Area {
  id
  name
  committee {
    ...Committee
  }
}
    ${CommitteeFragmentDoc}`;
export const DefaultMessageFragmentDoc = gql`
    fragment DefaultMessage on DefaultMessage {
  message
  status
}
    `;
export const IdeaExpectationFragmentDoc = gql`
    fragment IdeaExpectation on IdeaExpectation {
  id
  expectation
  expectationDescription
}
    `;
export const CountryFragmentDoc = gql`
    fragment Country on Country {
  id
  name
  flag
}
    `;
export const UnityFragmentDoc = gql`
    fragment Unity on Unity {
  id
  name
  country {
    ...Country
  }
}
    ${CountryFragmentDoc}`;
export const ChallengeFragmentDoc = gql`
    fragment Challenge on Challenge {
  id
  title
  name
  type
  status
  language
  description
  isDateSensitive
  startDate
  endDate
  createdAt
}
    `;
export const IdeaConclusionFragmentDoc = gql`
    fragment IdeaConclusion on IdeaConclusion {
  id
  createdAt
  financialVote
  prize
  points
  productivityVote
  sustainabilityVote
  productivityVoteDescription
  financialVoteDescription
  sustainabilityVoteDescription
}
    `;
export const IdeaFragmentDoc = gql`
    fragment Idea on Idea {
  id
  status
  title
  code
  nameCode
  currentProblem
  problemSolution
  description
  motive
  authorName
  father {
    status
  }
  expectations {
    id
    challengeLanguage
    expectation
    expectationDescription
  }
  sons {
    id
    title
    motive
    description
    challengeLanguage
    productiveDescription
    analysisDescription
    implementationResume
    expectations {
      isSelected
      id
      expectationDescription
      expectation
      challengeLanguage
    }
  }
  ideafiles {
    file
    fileName
    id
  }
  challengeLanguage
  role
  re
  turn
  managerName
  phone
  phoneExtensionLine
  costCenter
  contactHour
  productivityValueHH
  productivityValueHM
  analysisFinacialreturn
  analysisSustainability
  productiveEquipament
  productiveDescription
  areaResponsible
  areaExtensionLine
  email
  likes
  financeValue
  createdAt
  updatedAt
  endedAction
  blocked
  premiationDate
  sustentabilityPoint
  authors {
    id
    name
    re
    area
    jobRole
    cpf
    email
    costCenter
    remove
    justification
  }
  tags {
    id
    tag
  }
  action {
    id
    code
    title
    description
    status
    endDate
    startDate
    createdAt
    updatedAt
  }
  implementationResume
  analysisManValue
  analysisMachineValue
  analysisSustainability
  analysisFinacialreturn
  expectations {
    ...IdeaExpectation
  }
  unity {
    ...Unity
  }
  challenge {
    ...Challenge
  }
  committee {
    ...Committee
  }
  conclusion {
    ...IdeaConclusion
  }
  sustainabilities {
    id
    name
    quantity
    unity
    pontuation
  }
}
${IdeaExpectationFragmentDoc}
${UnityFragmentDoc}
${ChallengeFragmentDoc}
${CommitteeFragmentDoc}
${IdeaConclusionFragmentDoc}`;
export const ActionTaskFragmentDoc = gql`
    fragment ActionTask on ActionTask {
  id
  status
  description
  createdAt
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  email
  photo
  role
}
    `;
export const ActionCommentFragmentDoc = gql`
    fragment ActionComment on ActionComment {
  id
  comment
  user {
    ...User
  }
  createdAt
}
    ${UserFragmentDoc}`;
export const ActionFragmentDoc = gql`
    fragment Action on Action {
  id
  code
  title
  description
  status
  startDate
  endDate
  createdAt
  updatedAt
  files {
    id
    url
    fileName
    name
  }
  responsible {
    id
    name
    email
    role
    photo
  }
  idea {
    ...Idea
  }
  history {
    id
    action {
      code
    }
    after
    before
    createdAt
    type
    user {
      name
    }
  }
  tasks {
    ...ActionTask
  }
  comments {
    ...ActionComment
  }
}
    ${IdeaFragmentDoc}
${ActionTaskFragmentDoc}
${ActionCommentFragmentDoc}`;
export const ActionKambanFragmentDoc = gql`
    fragment ActionKamban on ActionKamban {
  commentsCount
  doneTasks
  filesCount
  totalTasks
  isDelayed
  action {
    ...Action
  }
}
    ${ActionFragmentDoc}`;
export const KambanFragmentDoc = gql`
    fragment Kamban on Kamban {
  name
  cards {
    ...ActionKamban
  }
}
    ${ActionKambanFragmentDoc}`;
export const HomeFragmentDoc = gql`
    fragment Home on Home {
  ideas {
    ...Idea
  }
  tasksCanceled
  tasksDone
  tasksInProgress
  tasksPending
  pageSize
  currentPage
  nextPage
  previouPage
  totalCount
}
    ${IdeaFragmentDoc}`;
export const IdeaPageFragmentDoc = gql`
    fragment IdeaPage on IdeaPage {
  ideas {
    ...Idea
  }
  currentPage
  nextPage
  pageSize
  previouPage
  totalCount
  totalPage
}
    ${IdeaFragmentDoc}`;
export const NewsFragmentDoc = gql`
    fragment News on News {
  id
  createdAt
  updatedAt
  title
  description
  content
  author
  status
  imageUrl
  tags {
    id
    tag
  }
}
    `;
export const NewsPageFragmentDoc = gql`
    fragment NewsPage on NewsPage {
  news {
    ...News
  }
  currentPage
  nextPage
  pageSize
  previouPage
  totalCount
  totalPage
}
    ${NewsFragmentDoc}`;
export const PageChallengeFragmentDoc = gql`
    fragment PageChallenge on PageChallenge {
  results {
    ...Challenge
  }
  currentPage
  nextPage
  pageSize
  previouPage
  totalCount
  totalPage
}
    ${ChallengeFragmentDoc}`;
export const SearchActionDocument = gql`
    query SearchAction($input: SearchActionInput!) {
  searchAction(data: $input) {
    ...Kamban
    cards {
      action {
        ...Action
      }
    }
  }
}
    ${KambanFragmentDoc}
${ActionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchActionGQL extends Apollo.Query<SearchActionQuery, SearchActionQueryVariables> {
    document = SearchActionDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchActionHistoryDocument = gql`
    query SearchActionHistory($id: String!, $page: Float!) {
  actionHistory(id: $id, page: $page) {
    currentPage
    history {
      user {
        name
      }
      action {
        history {
          user {
            name
          }
        }
      }
      changedData
      after
      before
      createdAt
      id
      type
    }
    nextPage
    pageSize
    previouPage
    totalCount
    totalPage
  }
}
    `;
export type UpdateIdeaMutationVariables = Exact<{
  input: UpdateIdeaInput;
}>;

export type UpdateIdeaMutation = {
  updateIdea: { id: string; idea: UpdateIdeaInput };
};

export const UpdateIdeaDocument = gql`
  mutation UpdateIdea($input: UpdateIdeaInput!) {
    updateIdea(data: $input) {
      ...Idea
    }
  }
  ${IdeaFragmentDoc}
`;

@Injectable({
  providedIn: "root",
})
export class UpdateIdeaGQL extends Apollo.Mutation<
  UpdateIdeaMutation,
  UpdateIdeaMutationVariables
> {
  document = UpdateIdeaDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}


  @Injectable({
    providedIn: 'root'
  })
  export class SearchActionHistoryGQL extends Apollo.Query<SearchActionHistoryQuery, SearchActionHistoryQueryVariables> {
    document = SearchActionHistoryDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionStatusDocument = gql`
    mutation UpdateActionStatus($id: ID!, $status: String!) {
  updateActionStatus(id: $id, status: $status) {
    ...Action
  }
}
    ${ActionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionStatusGQL extends Apollo.Mutation<UpdateActionStatusMutation, UpdateActionStatusMutationVariables> {
    document = UpdateActionStatusDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateActionDocument = gql`
    mutation CreateAction($input: CreateActionInput!) {
  createAction(data: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateActionGQL extends Apollo.Mutation<CreateActionMutation, CreateActionMutationVariables> {
    document = CreateActionDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionDocument = gql`
    mutation UpdateAction($input: UpdateActionInput!) {
  updateAction(data: $input) {
    message
  }
}
    `;



export const GetActionByIdDocument = gql`
query Action($id: ID!) {
  action(id: $id) {
    id
    tasks {
      id
      status
      description
      createdAt
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActionByIdGQL extends Apollo.Query<GetActionByIdQuery, GetActionByIdQueryVariables> {
    document = GetActionByIdDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }


  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionGQL extends Apollo.Mutation<UpdateActionMutation, UpdateActionMutationVariables> {
    document = UpdateActionDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateActionCommentDocument = gql`
    mutation CreateActionComment($input: CreateActionCommentInput!) {
  createActionComment(data: $input) {
    ...ActionComment
  }
}
    ${ActionCommentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateActionCommentGQL extends Apollo.Mutation<CreateActionCommentMutation, CreateActionCommentMutationVariables> {
    document = CreateActionCommentDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateActionTaskDocument = gql`
    mutation CreateActionTask($input: CreateActionTaskInput!) {
  createActionTask(data: $input) {
    ...ActionTask
  }
}
    ${ActionTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateActionTaskGQL extends Apollo.Mutation<CreateActionTaskMutation, CreateActionTaskMutationVariables> {
    document = CreateActionTaskDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionTaskStatusDocument = gql`
    mutation UpdateActionTaskStatus($id: ID!) {
  updateActionTaskStatus(id: $id) {
    ...ActionTask
  }
}
    ${ActionTaskFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionTaskStatusGQL extends Apollo.Mutation<UpdateActionTaskStatusMutation, UpdateActionTaskStatusMutationVariables> {
    document = UpdateActionTaskStatusDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveActionTaskDocument = gql`
    mutation RemoveActionTask($id: ID!) {
  removeActionTask(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveActionTaskGQL extends Apollo.Mutation<RemoveActionTaskMutation, RemoveActionTaskMutationVariables> {
    document = RemoveActionTaskDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveActionFileDocument = gql`
    mutation RemoveActionFile($id: ID!) {
  removeActionFile(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveActionFileGQL extends Apollo.Mutation<RemoveActionFileMutation, RemoveActionFileMutationVariables> {
    document = RemoveActionFileDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActionStatusDocument = gql`
    query ActionStatus {
  actionStatus
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActionStatusGQL extends Apollo.Query<ActionStatusQuery, ActionStatusQueryVariables> {
    document = ActionStatusDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAreaDocument = gql`
    query SearchArea($input: SearchAreaInput!) {
  searchArea(data: $input) {
    ...Area
  }
}
    ${AreaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAreaGQL extends Apollo.Query<SearchAreaQuery, SearchAreaQueryVariables> {
    document = SearchAreaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AreasDocument = gql`
    query Areas {
  areas {
    ...Area
  }
}
    ${AreaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AreasGQL extends Apollo.Query<AreasQuery, AreasQueryVariables> {
    document = AreasDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAreaDocument = gql`
    mutation CreateArea($input: CreateAreaInput!) {
  createArea(data: $input) {
    ...Area
  }
}
    ${AreaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAreaGQL extends Apollo.Mutation<CreateAreaMutation, CreateAreaMutationVariables> {
    document = CreateAreaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAreaDocument = gql`
    mutation UpdateArea($input: UpdateAreaInput!) {
  updateArea(data: $input) {
    ...Area
  }
}
    ${AreaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAreaGQL extends Apollo.Mutation<UpdateAreaMutation, UpdateAreaMutationVariables> {
    document = UpdateAreaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveAreaDocument = gql`
    mutation RemoveArea($id: ID!) {
  removeArea(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveAreaGQL extends Apollo.Mutation<RemoveAreaMutation, RemoveAreaMutationVariables> {
    document = RemoveAreaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PageChallengesDocument = gql`
    query PageChallenges($data: SearchChallengeInput!) {
  pageChallenges(filter: $data) {
    ...PageChallenge
  }
}
    ${PageChallengeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PageChallengesGQL extends Apollo.Query<PageChallengesQuery, PageChallengesQueryVariables> {
    document = PageChallengesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateChallengeDocument = gql`
    mutation CreateChallenge($data: CreateChallengeInput!) {
  createChallenge(data: $data) {
    ...Challenge
  }
}
    ${ChallengeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateChallengeGQL extends Apollo.Mutation<CreateChallengeMutation, CreateChallengeMutationVariables> {
    document = CreateChallengeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateChallengeDocument = gql`
    mutation UpdateChallenge($language: String!, $data: UpdateChallengeInput!) {
  updateChallenge(language: $language, data: $data) {
    ...Challenge
  }
}
    ${ChallengeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateChallengeGQL extends Apollo.Mutation<UpdateChallengeMutation, UpdateChallengeMutationVariables> {
    document = UpdateChallengeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveChallengeDocument = gql`
    mutation RemoveChallenge($language: String!, $id: String!) {
  removeChallenge(language: $language, id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveChallengeGQL extends Apollo.Mutation<RemoveChallengeMutation, RemoveChallengeMutationVariables> {
    document = RemoveChallengeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommitteesDocument = gql`
    query Committees {
  committees {
    ...Committee
  }
}
    ${CommitteeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommitteesGQL extends Apollo.Query<CommitteesQuery, CommitteesQueryVariables> {
    document = CommitteesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIdeaCommiteeByIdDocument = gql`
    query getIdeaCommiteeById($input: String!) {
  getIdea(id: $input) {
    id
    committee {
      id
      participants {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIdeaCommiteeByIdGQL extends Apollo.Query<GetIdeaCommiteeByIdQuery, GetIdeaCommiteeByIdQueryVariables> {
    document = GetIdeaCommiteeByIdDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchCommitteeDocument = gql`
    query SearchCommittee($input: SearchCommittee!) {
  searchCommittee(data: $input) {
    ...Committee
  }
}
    ${CommitteeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchCommitteeGQL extends Apollo.Query<SearchCommitteeQuery, SearchCommitteeQueryVariables> {
    document = SearchCommitteeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommitteeDocument = gql`
    mutation CreateCommittee($input: CreateCommitteeInput!) {
  createCommittee(createCommitteeInput: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommitteeGQL extends Apollo.Mutation<CreateCommitteeMutation, CreateCommitteeMutationVariables> {
    document = CreateCommitteeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommitteeDocument = gql`
    mutation UpdateCommittee($input: UpdateCommitteeInput!) {
  updateCommittee(data: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommitteeGQL extends Apollo.Mutation<UpdateCommitteeMutation, UpdateCommitteeMutationVariables> {
    document = UpdateCommitteeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCommitteeDocument = gql`
    mutation RemoveCommittee($id: ID!) {
  removeCommittee(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCommitteeGQL extends Apollo.Mutation<RemoveCommitteeMutation, RemoveCommitteeMutationVariables> {
    document = RemoveCommitteeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = gql`
    query GetCountries {
  getCountries {
    ...Country
  }
}
    ${CountryFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    document = GetCountriesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HomeDocument = gql`
    query Home($page: Float!) {
  home(page: $page) {
    ...Home
  }
}
    ${HomeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class HomeGQL extends Apollo.Query<HomeQuery, HomeQueryVariables> {
    document = HomeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchAllIdeasDocument = gql`
    query SearchAllIdeas($input: SearchIdeaInput!) {
  searchAllIdeas(data: $input) {
    ...IdeaPage
  }
}
    ${IdeaPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchAllIdeasGQL extends Apollo.Query<SearchAllIdeasQuery, SearchAllIdeasQueryVariables> {
    document = SearchAllIdeasDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIdeaDocument = gql`
    query GetIdea($id: String!) {
  getIdea(id: $id) {
    ...Idea
  }
}
    ${IdeaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIdeaGQL extends Apollo.Query<GetIdeaQuery, GetIdeaQueryVariables> {
    document = GetIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetIdeasDocument = gql`
    query GetIdeas {
  getIdeas {
    ...Idea
  }
}
    ${IdeaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIdeasGQL extends Apollo.Query<GetIdeasQuery, GetIdeasQueryVariables> {
    document = GetIdeasDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuthorsDocument = gql`
    query GetAuthors {
  getAuthors {
    authorName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuthorsGQL extends Apollo.Query<GetAuthorsQuery, GetAuthorsQueryVariables> {
    document = GetAuthorsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IdeaByStatusDocument = gql`
    query IdeaByStatus($status: [String!]!) {
  ideaByStatus(status: $status) {
    ...Idea
  }
}
    ${IdeaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IdeaByStatusGQL extends Apollo.Query<IdeaByStatusQuery, IdeaByStatusQueryVariables> {
    document = IdeaByStatusDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ValidateApproveDocument = gql`
    query ValidateApprove($id: String!) {
  validateApproveIdea(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateApproveGQL extends Apollo.Query<ValidateApproveQuery, ValidateApproveQueryVariables> {
    document = ValidateApproveDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptIdeaDocument = gql`
    mutation AcceptIdea($input: AcceptIdeaInput!) {
  acceptIdea(data: $input) {
    ...Idea
  }
}
    ${IdeaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptIdeaGQL extends Apollo.Mutation<AcceptIdeaMutation, AcceptIdeaMutationVariables> {
    document = AcceptIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApprovedIdeaDocument = gql`
    mutation ApprovedIdea($input: ApproveIdeaInput!) {
  approvedIdea(data: $input) {
    ...Idea
  }
}
    ${IdeaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ApprovedIdeaGQL extends Apollo.Mutation<ApprovedIdeaMutation, ApprovedIdeaMutationVariables> {
    document = ApprovedIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIdeaConclusionDocument = gql`
    mutation CreateIdeaConclusion($input: CreateIdeaConclusionInput!) {
  createIdeaConclusion(data: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIdeaConclusionGQL extends Apollo.Mutation<CreateIdeaConclusionMutation, CreateIdeaConclusionMutationVariables> {
    document = CreateIdeaConclusionDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIdeaConclusionDocument = gql`
    mutation UpdateIdeaConclusion($input: UpdateIdeaConclusionInput!) {
  updateIdeaConclusion(data: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIdeaConclusionGQL extends Apollo.Mutation<UpdateIdeaConclusionMutation, UpdateIdeaConclusionMutationVariables> {
    document = UpdateIdeaConclusionDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AwardIdeaDocument = gql`
    mutation AwardIdea($input: String!) {
  awardIdea(id: $input) {
    ...Idea
  }
}
    ${IdeaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AwardIdeaGQL extends Apollo.Mutation<AwardIdeaMutation, AwardIdeaMutationVariables> {
    document = AwardIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIdeaImplementationDocument = gql`
    mutation UpdateIdeaImplementation($input: UpdateIdeaImplementationInput!) {
  updateIdeaImplementation(data: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateIdeaImplementationGQL extends Apollo.Mutation<UpdateIdeaImplementationMutation, UpdateIdeaImplementationMutationVariables> {
    document = UpdateIdeaImplementationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReproveIdeaDocument = gql`
    mutation ReproveIdea($input: ReproveIdeaInput!) {
  reproveIdea(data: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReproveIdeaGQL extends Apollo.Mutation<ReproveIdeaMutation, ReproveIdeaMutationVariables> {
    document = ReproveIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveFileDocument = gql`
    mutation RemoveFile($id: String!) {
  removeFile(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveFileGQL extends Apollo.Mutation<RemoveFileMutation, RemoveFileMutationVariables> {
    document = RemoveFileDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TranslateIdeaDocument = gql`
    mutation TranslateIdea($input: [TranslateIdeaInput!]!) {
  translateIdea(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TranslateIdeaGQL extends Apollo.Mutation<TranslateIdeaMutation, TranslateIdeaMutationVariables> {
    document = TranslateIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetChallengesByLanguageAllDocument = gql`
    query GetChallengesByLanguageAll($input: String!) {
  getChallengesByLanguageAll(language: $input) {
    createdAt
    deletedAt
    description
    endDate
    id
    isDateSensitive
    language
    name
    startDate
    status
    title
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetChallengesByLanguageAllGQL extends Apollo.Query<GetChallengesByLanguageAllQuery, GetChallengesByLanguageAllQueryVariables> {
    document = GetChallengesByLanguageAllDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DenyIdeaDocument = gql`
    mutation DenyIdea($id: String!) {
  denyIdea(id: $id) {
    ...Idea
  }
}
    ${IdeaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DenyIdeaGQL extends Apollo.Mutation<DenyIdeaMutation, DenyIdeaMutationVariables> {
    document = DenyIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateIdeaCommitteeDocument = gql`
    mutation UpdateIdeaCommittee($input: UpdateIdeaCommitteeInput!) {
  updateIdeaCommittee(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;
@Injectable({
  providedIn: 'root'
})
export class UpdateIdeaCommitteeGQL extends Apollo.Mutation<UpdateIdeaCommitteeMutation, UpdateIdeaCommitteeMutationVariables> {
  document = UpdateIdeaCommitteeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const UpdateIdeaCodeDocument = gql`
    mutation UpdateIdeaCode($input: UpdateIdeaCodeInput!) {
  updateIdeaCode(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

@Injectable({
  providedIn: 'root'
})
export class UpdateIdeaCodeGQL extends Apollo.Mutation<UpdateIdeaCodeMutation, UpdateIdeaCodeMutationVariables> {
  document = UpdateIdeaCodeDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const UpdateIdeaStatusDocument = gql`
    mutation UpdateIdeaStatus($input: UpdateIdeaStatusInput!) {
  updateIdeaStatus(data: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

@Injectable({
  providedIn: 'root'
})
export class UpdateIdeaStatusGQL extends Apollo.Mutation<UpdateIdeaStatusMutation, UpdateIdeaStatusMutationVariables> {
  document = UpdateIdeaStatusDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const RemoveIdeaDocument = gql`
    mutation RemoveIdea($id: ID!) {
  removeIdea(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveIdeaGQL extends Apollo.Mutation<RemoveIdeaMutation, RemoveIdeaMutationVariables> {
    document = RemoveIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNewsSearchDocument = gql`
    query GetNewsSearch($page: Int!, $status: String!, $language: String!, $input: String!) {
  getNewsSearch(
    page: $page
    status: $status
    language: $language
    keyword: $input
  ) {
    ...NewsPage
  }
}
    ${NewsPageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNewsSearchGQL extends Apollo.Query<GetNewsSearchQuery, GetNewsSearchQueryVariables> {
    document = GetNewsSearchDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNewDocument = gql`
    query GetNew($input: String!) {
  getNew(id: $input) {
    ...News
  }
}
    ${NewsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNewGQL extends Apollo.Query<GetNewQuery, GetNewQueryVariables> {
    document = GetNewDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNewsDocument = gql`
    mutation CreateNews($data: CreateNewsInput!) {
  createNews(data: $data) {
    ...News
  }
}
    ${NewsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNewsGQL extends Apollo.Mutation<CreateNewsMutation, CreateNewsMutationVariables> {
    document = CreateNewsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateNewsDocument = gql`
    mutation UpdateNews($data: UpdateNewsInput!) {
  updateNews(data: $data) {
    ...News
  }
}
    ${NewsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateNewsGQL extends Apollo.Mutation<UpdateNewsMutation, UpdateNewsMutationVariables> {
    document = UpdateNewsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveNewsDocument = gql`
    mutation RemoveNews($input: String!) {
  removeNews(id: $input) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveNewsGQL extends Apollo.Mutation<RemoveNewsMutation, RemoveNewsMutationVariables> {
    document = RemoveNewsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddNewsTagsDocument = gql`
    mutation AddNewsTags($input: [String!]!, $id: ID!) {
  addNewsTags(tag: $input, id: $id) {
    ...News
  }
}
    ${NewsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewsTagsGQL extends Apollo.Mutation<AddNewsTagsMutation, AddNewsTagsMutationVariables> {
    document = AddNewsTagsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnitiesDocument = gql`
    query GetUnities {
  getUnities {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitiesGQL extends Apollo.Query<GetUnitiesQuery, GetUnitiesQueryVariables> {
    document = GetUnitiesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUnityDocument = gql`
    query SearchUnity($input: SearchUnityInput!) {
  searchUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUnityGQL extends Apollo.Query<SearchUnityQuery, SearchUnityQueryVariables> {
    document = SearchUnityDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUnityDocument = gql`
    mutation CreateUnity($input: CreateUnityInput!) {
  createUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUnityGQL extends Apollo.Mutation<CreateUnityMutation, CreateUnityMutationVariables> {
    document = CreateUnityDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUnityDocument = gql`
    mutation UpdateUnity($input: UpdateUnityInput!) {
  updateUnity(data: $input) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUnityGQL extends Apollo.Mutation<UpdateUnityMutation, UpdateUnityMutationVariables> {
    document = UpdateUnityDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUnityDocument = gql`
    mutation RemoveUnity($id: String!) {
  removeUnity(id: $id) {
    ...DefaultMessage
  }
}
    ${DefaultMessageFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUnityGQL extends Apollo.Mutation<RemoveUnityMutation, RemoveUnityMutationVariables> {
    document = RemoveUnityDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUnitiesByCountryDocument = gql`
    query GetUnitiesByCountry($countryId: String!) {
  getUnitiesByCountry(id: $countryId) {
    ...Unity
  }
}
    ${UnityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitiesByCountryGQL extends Apollo.Query<GetUnitiesByCountryQuery, GetUnitiesByCountryQueryVariables> {
    document = GetUnitiesByCountryDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation Login($code: String!, $redirectUri: String!, $email: String!, $application: String!) {
  login(
    data: {application: $application, code: $code, redirectUri: $redirectUri, email: $email}
  ) {
    user {
      ...User
    }
    token
    country
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeDocument = gql`
    query Me {
  me {
    ...User
    unity {
      id
    }
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    document = MeDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersDocument = gql`
    query GetUsers {
  getUsers {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
    document = GetUsersDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchUserDocument = gql`
    query SearchUser($input: SearchUserInput!) {
  searchUser(data: $input) {
    results {
      ...User
      unity {
        id
        name
        country {
          id
          name
        }
      }
      employee {
        id
        re
      }
      committeeManager {
        id
        name
      }
      committeeParticipants {
        id
        name
      }
    }
    totalPages
    currentPage
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchUserGQL extends Apollo.Query<SearchUserQuery, SearchUserQueryVariables> {
    document = SearchUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(data: $input) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!, $id: String!) {
  updateUser(data: $input, id: $id) {
    ...User
  }
}
    ${UserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveUserDocument = gql`
    mutation RemoveUser($id: String!) {
  removeUser(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveUserGQL extends Apollo.Mutation<RemoveUserMutation, RemoveUserMutationVariables> {
    document = RemoveUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationDocument = gql`
    query GetNotification {
  notificationsByUser {
    total
    unread
    notifications {
      id
      title
      message
      type
      isRead
      relationId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationGQL extends Apollo.Query<GetNotificationQuery, GetNotificationQueryVariables> {
    document = GetNotificationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReadNotificationDocument = gql`
    mutation ReadNotification($id: String!) {
  readNotification(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReadNotificationGQL extends Apollo.Mutation<ReadNotificationMutation, ReadNotificationMutationVariables> {
    document = ReadNotificationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

  export type CreateIdeaMutationVariables = Exact<{
    data: CreateIdeaInput;
  }>;


  export type CreateIdeaMutation = { createIdea: { id: string, title: string, description?: string | null | undefined, authorName: string, role?: string | null  | undefined, re: string, turn?: string | null | undefined, managerName?: string | null | undefined, phone?: string | null | undefined, costCenter?: string | null | undefined, contactHour?: string | null | undefined, productiveEquipament?: boolean, areaResponsible?: string | null | undefined, areaExtensionLine?: string | null | undefined, email?: string | null | undefined, createdAt: any, updatedAt: any, country?: { id: string, name: string } | null | undefined, authors?: Array<{ id: string, name: string, re: string }> | null | undefined, unity?: { id: string, name: string } | null | undefined, challenge?: { id: string, name: string } | null | undefined } };

  export const CreateIdeaDocument = gql`
  mutation Idea($data: CreateIdeaInput!) {
  createIdea(data: $data) {
  id
  title
  authorName
  re
  createdAt
  }
  }
  `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIdeaGQL extends Apollo.Mutation<CreateIdeaMutation, CreateIdeaMutationVariables> {
    document = CreateIdeaDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }

@Injectable({
    providedIn: 'root'
})
export class GetSustainabilitiesGQL extends Apollo.Query<GetSustainabilitiesQuery, GetSustainabilitiesQueryVariables> {
    document = GetSustainabilitiesDocument;

    constructor(apollo: Apollo.Apollo) {
        super(apollo);
    }
}
